import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { usePostcardShare } from "./share/usePostcardShare";
import { PostcardPreview } from "./share/PostcardPreview";
import { ShareActions } from "./share/ShareActions";

export default function ShareCardModal({ open, onClose }) {
  const s = usePostcardShare(open, onClose);
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose?.()}>
      <DialogContent
        className="w-[calc(100vw-1.5rem)] sm:w-full max-w-2xl max-h-[92dvh] overflow-y-auto overflow-x-hidden [&>*]:min-w-0 p-4 sm:p-6 bg-[#15111A] border border-[#C8A96E]/40 text-white"
        data-testid="share-card-modal"
      >
        <DialogHeader>
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#C8A96E]">Blueprint Postcard</div>
          <DialogTitle className="font-heading text-xl sm:text-3xl tracking-tighter mt-1">
            Share your celestial signal
          </DialogTitle>
          <p className="text-xs text-[#A89C98] mt-2 hidden sm:block">
            Your top city’s real skyline behind your name and resonance. Auto-refreshed from your highest scan.
          </p>
        </DialogHeader>

        {s.loading && (
          <div className="aspect-[1200/630] rounded-xl border border-white/10 flex items-center justify-center text-xs uppercase tracking-[0.3em] text-[#A89C98]" data-testid="postcard-generating">
            Casting your postcard…
          </div>
        )}

        {s.postcard && (
          <>
            <PostcardPreview postcard={s.postcard} format={s.format} setFormat={s.setFormat} imageUrl={s.imageUrl} imgLoaded={s.imgLoaded} setImgLoaded={s.setImgLoaded} />
            <ShareActions shareUrl={s.shareUrl} imageUrl={s.imageUrl} caption={s.caption} copied={s.copied} copyLink={s.copyLink} nativeShare={s.nativeShare} downloadPng={s.downloadPng} getPngFile={s.getPngFile} />
            <p className="mt-4 text-[10px] uppercase tracking-[0.25em] text-[#A89C98] text-center">
              {s.postcard.name} · {s.postcard.zodiac || "—"} · Score {s.postcard.score} in {s.postcard.city}
            </p>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
